import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseStoreFacade } from '@city/data-access';
import { HTTPMethod, InterceptorEndpoints } from '@core/const';
import { InterceptorEndpointService } from '@core/feature';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { ManualPriceFormItem, ManualPriceService } from './../services/manual-price.service';

@Injectable({ providedIn: 'root' })
export class ManualPriceInterceptor implements HttpInterceptor {
  entriesUrls: InterceptorEndpoints[] = [{ url: '/entries', methods: [HTTPMethod.POST] }];

  constructor(
    private manualPriceServcie: ManualPriceService,
    private baseStoreFacade: BaseStoreFacade,
    private interceptorEndpointService: InterceptorEndpointService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.interceptorEndpointService.requestIsIntercept(req, this.entriesUrls)) {
      let key: string;

      return this.baseStoreFacade.getActiveCode().pipe(
        take(1),
        switchMap((baseStoreCode) => {
          key = this.manualPriceServcie.keyGenerator(
            this.getParamsFromUrl(req.urlWithParams, 'unit'),
            this.getParamsFromUrl(req.urlWithParams, 'code'),
            baseStoreCode,
          );

          return this.manualPriceServcie.getPriceItem(key);
        }),
        take(1),
        switchMap((priceItem: ManualPriceFormItem) => {
          if (!priceItem) {
            return next.handle(req);
          }

          return priceItem.isPriceEmpty$.pipe(
            take(1),
            switchMap((isEmpty: boolean) => {
              if (isEmpty) {
                return next.handle(req);
              } else {
                const price = priceItem.form.get('price').value;
                if (price) {
                  const requestToHandle = req.clone({
                    params: req.params.set('price', price),
                  });

                  return next.handle(requestToHandle);
                }

                return next.handle(req);
              }
            }),
          );
        }),
      );
    }

    return next.handle(req);
  }

  getParamsFromUrl(url: string, param: string): string {
    return url
      .split('?')[1]
      .split('&')
      .find((item: string) => item.includes(param))
      ?.split('=')[1];
  }
}
